import axios from "axios";

const endpoint_url = "/campaignV2/customer/instantLuckyDraw/presetWinner";

const presetWinner = ({ instantLuckyDrawId, winnerField }) => {
  const body = {
    instantLuckyDrawId: instantLuckyDrawId,
    winnerField: winnerField,
  };

  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default presetWinner;
